import Wrapper from './_views/Wrapper.vue';

const parentRouteConfig = {
  name: 'Press Sheets',
  to: {
    name: 'pressSheets',
    query: {
      pageNum: '1',
      suffix: '',
    },
  },
};

export default {
  path: '/press-sheets',
  component: Wrapper,
  children: [
    {
      path: '',
      name: 'pressSheets',
      component: () => import(/* webpackChunkName: "pressSheets" */ './_views/KernelPressSheets.vue'),
      meta: {
        title: 'Press Sheets',
        navigation: {
          position: 6,
          name: 'Press Sheets',
          icon: 'layers',
          specialQueries: ['suffix'],
          to: {
            name: 'pressSheets',
            query: {
              suffix: '',
              pageNum: '1',
            },
          },
        },
      },
    },
    {
      path: ':id',
      name: 'pressSheet',
      component: () => import(/* webpackChunkName: "pressSheet" */ './_views/KernelPressSheet.vue'),
      meta: {
        title: 'Press Sheets',
        parent: parentRouteConfig,
      },
    },
  ],
};
